<template>
  <div id="pantallajuego">
    <div v-if="comenzo == false">
      <section id="dinamica" class="bgbeige">
        <div class="container">
          <div class="row pt-lg-5">
            <div class="col-12 text-center pt-5 pt-lg-5 px-5">
              <div class="row">
                <div class="col-12 text-center azul fXG pb-4 pt-lg-5">
                  ¡Hola <span class="bold">{{ userProfile.nombre }}</span>
                  <img
                    src="../assets/imgs/playasol/exclamacion.jpg"
                    alt="exclamacion"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-center fG">
                  <span class="black">
                    <span class="bold">Tu misión es descubrir</span> la
                    ubicación de los costales de cemento escondidos a lo largo
                    de la embarcación, antes de que pasen <b>30 segundos</b>.
                    <br /><br />
                    Buena suerte con la búsqueda. 
                    <br /><br />

                    <span class="" v-if="isMobile === true">
                      Voltea tu celular de manera horizontal para jugar. <br />
                      <img
                        class="pt-5 img-fluid px-5"
                        src="../assets/imgs/playasol/horizontal-smartphone.png"
                        alt="smartphone"
                      />
                    </span>
                  </span>
                </div>
              </div>

              <button
                @click="initJuego()"
                class="my-5 pointer d-inline-block align-items-center justify-content-center btnaction fG ml-auto mr-auto"
              >
                Comenzar
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-12 py-5"></div>
            <div class="col-12 py-5"></div>

            <div class="col-12 pt-5">
              <!-- <p class="text-center bold grisoscuro">
                Promoción vigente del 15 de mayo de 2023 al 09 de julio de 2023.
              </p> -->
              <p class="text-center fG">
                Dudas o información de la promoción comunícate al 55 9435
                    6588
                de lunes a viernes de 09:00 a 18:00 hrs.
              </p>
            </div>
          </div>
        </div>

        <Footer></Footer>
      </section>
    </div>
    <div v-else>
      <section id="juego" class="" v-if="nivel != null" >
        <div class="imagen">
          <img
            @load="onImageLoad()"
            class="w-100"
            :src="
              require('../assets/imgs/playasol/costales/juego-' +
                nivel +
                '.jpg')
            "
            alt="Juego"
          />

          <div v-if="imageLoadFlag === true" class="overlaypos" :class="{n1: nivel == 1, n2: nivel == 2, n3: nivel == 3, n4: nivel == 4, n5: nivel == 5,  n6: nivel == 6, n7: nivel == 7,  n8: nivel == 8,  n9: nivel == 9 }">


            <div class="adornos">
              <img v-if="nivel == 1" class="n1" src="../assets/imgs/playasol/costales/adorno1.gif" alt="adorno">
              <img v-if="nivel == 2" class="n1" src="../assets/imgs/playasol/costales/adorno1.gif" alt="adorno">
              <img v-if="nivel == 3" class="n1" src="../assets/imgs/playasol/costales/adorno1.gif" alt="adorno">

              <img v-if="nivel == 4" class="n4" src="../assets/imgs/playasol/costales/adorno2.gif" alt="adorno">
              <img v-if="nivel == 5" class="n4" src="../assets/imgs/playasol/costales/adorno2.gif" alt="adorno">
              <img v-if="nivel == 6" class="n4" src="../assets/imgs/playasol/costales/adorno2.gif" alt="adorno">

              <img v-if="nivel == 7" class="n7" src="../assets/imgs/playasol/costales/adorno3.gif" alt="adorno">
              <img v-if="nivel == 8" class="n7" src="../assets/imgs/playasol/costales/adorno3.gif" alt="adorno">
              <img v-if="nivel == 9" class="n7" src="../assets/imgs/playasol/costales/adorno3.gif" alt="adorno">

            </div>

            <div class="p1">
              <img
                @click="clickElemento(1)"
                class="w-100"
                :src="require('../assets/imgs/playasol/costales/costal-'+nivel+'-1.jpg')"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p1'].encontrada === true"
              ></div>
            </div>
            <div class="p2">
              <img
                @click="clickElemento(2)"
                class="w-100"
                :src="require('../assets/imgs/playasol/costales/costal-'+nivel+'-2.jpg')"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p2'].encontrada === true"
              ></div>
            </div>
            <div class="p3">
              <img
                @click="clickElemento(3)"
                class="w-100"
                :src="require('../assets/imgs/playasol/costales/costal-'+nivel+'-3.jpg')"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p3'].encontrada === true"
              ></div>
            </div>

            <div class="p4">
              <img
                @click="clickElemento(4)"
                class="w-100"
                :src="require('../assets/imgs/playasol/costales/costal-'+nivel+'-4.jpg')"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p4'].encontrada === true"
              ></div>
            </div>

            <div class="p5">
              <img
                @click="clickElemento(5)"
                class="w-100"
                :src="require('../assets/imgs/playasol/costales/costal-'+nivel+'-5.jpg')"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p5'].encontrada === true"
              ></div>
            </div>

            <!-- <div class="p6">
              <img
                @click="clickElemento(6)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-6.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p6'].encontrada === true"
              ></div>
            </div>
            <div class="p7">
              <img
                @click="clickElemento(7)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-7.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p7'].encontrada === true"
              ></div>
            </div>
            <div class="p8">
              <img
                @click="clickElemento(8)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-8.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p8'].encontrada === true"
              ></div>
            </div>
            <div class="p9">
              <img
                @click="clickElemento(9)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-9.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p9'].encontrada === true"
              ></div>
            </div>
            <div class="p10">
              <img
                @click="clickElemento(10)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-10.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p10'].encontrada === true"
              ></div>
            </div>
            <div class="p11">
              <img
                @click="clickElemento(11)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-11.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p11'].encontrada === true"
              ></div>
            </div>
            <div class="p12">
              <img
                @click="clickElemento(12)"
                class="w-100"
                src="../assets/imgs/playasol/costales/pringles-12.png"
                alt="Pringles"
              />
              <div
                class="encontrada"
                v-show="latas['p12'].encontrada === true"
              ></div>
            </div> -->
          </div>
        </div>

        <div class="score">
          <img
            class="w-100"
            src="../assets/imgs/playasol/bg-score.png"
            alt="score"
          />

          <div class="texto">
            <div class="botes">
              <div class="circulo">
                <div class="bold fpC">COSTALES</div>
                <div class="bold fpG">{{ encontradas }}</div>
              </div>
            </div>
            <div class="tiempo">
              <div class="fpC">TIEMPO</div>
              <div class="fpG bold">{{ time }}</div>
            </div>
          </div>
        </div>
      </section>

      <span
        class="loading"
        v-bind:class="{ active: this.$store.state.loading }"
      >
        <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
      </span>
    </div>

    <div class="hidden" v-for="pregunta in preguntas" :key="pregunta.id">
      <img
        rel="preload"
        :src="
          require('../assets/imgs/playasol/trivia/P' + pregunta.id + '.jpg')
        "
        alt="preloaded"
      />
    </div>
  </div>
</template>

<script>
import { commentsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import AOS from "aos";
import swal from "sweetalert2";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const TIEMPO_PARTICIPACION = 20;
const MAX_MATCHES = 35;
const MAX_NOMATCHES = 45;
const MAX_COCACINEPOLIS = 20;
const MAX_TARJETAS = MAX_MATCHES + MAX_COCACINEPOLIS + MAX_NOMATCHES;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: false,

      time_init: 0,
      time_txt: TIEMPO_PARTICIPACION,
      ahora: moment(),
      indice: 0,
      respuesta_actual: null,
      puntos: 0,
      respuestas: {
        res: [],
        correctas: 0,
      },

      dulceria: [],
      siluetas: [],
      preguntas: [],
      disponibles_temp: [],
      dulceria_temp: [],
      matches_final: [],
      matches: [],
      nomatches: [],
      cocacinepolis: [],
      preguntas_listas: false,
      indice_pregunta: 0,
      termino: false,
      comenzo: false,
      standBy: false,
      showSplash: false,
      cards: [],
      started: false,
      startTime: 0,
      turns: 0,
      flipBackTimer: null,
      timer: null,
      time: "--:--",
      score: 0,
      latas: {
        p1: {
          encontrada: false,
        },
        p2: {
          encontrada: false,
        },
        p3: {
          encontrada: false,
        },
        p4: {
          encontrada: false,
        },
        p5: {
          encontrada: false,
        },
        p6: {
          encontrada: false,
        },
        p7: {
          encontrada: false,
        },
        p8: {
          encontrada: false,
        },
        p9: {
          encontrada: false,
        },
        p10: {
          encontrada: false,
        },
        p11: {
          encontrada: false,
        },
        p12: {
          encontrada: false,
        },
      },
      encontradas: "00",
      encontradas_x_nivel: 0,
      segundos: 0,
      isMobile: false,
      nivel: null,
      variante: 1,
      initialValues: [1,2,3,4,5,6,7,8],
      currentArray: [],
      imageLoadFlag: false
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    
    this.isMobile = this.checkIfMobile();
    console.log({ isMobile: this.isMobile });

    this.resetArray();
    this.pickRandomNumber();
    


    console.log({ nivel: this.nivel });
  },
  created() {
    //
  },
  methods: {
    resetArray() {
      this.currentArray = [...this.initialValues];
    },
    cambiaNivel() {
      this.latas = {
        p1: {
          encontrada: false,
        },
        p2: {
          encontrada: false,
        },
        p3: {
          encontrada: false,
        },
        p4: {
          encontrada: false,
        },
        p5: {
          encontrada: false,
        },
        p6: {
          encontrada: false,
        },
        p7: {
          encontrada: false,
        },
        p8: {
          encontrada: false,
        },
        p9: {
          encontrada: false,
        },
        p10: {
          encontrada: false,
        },
        p11: {
          encontrada: false,
        },
        p12: {
          encontrada: false,
        },
      };

      this.pickRandomNumber();
    },
    pickRandomNumber() {
      this.encontradas_x_nivel = 0;
      this.imageLoadFlag = false;
      if (this.currentArray.length === 0) {
        this.resetArray();
      }

      const randomIndex = Math.floor(Math.random() * this.currentArray.length);
      this.nivel = this.currentArray.splice(randomIndex, 1)[0];
    },
    checkIfMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    resetDisponibles() {
      // this.disponibles_temp = [...this.siluetas];
      // this.disponibles_temp = this.shuffle(this.disponibles_temp);
      //console.log({ reset: this.disponibles_temp });

      let thes = this;
      this.disponibles_temp = [...this.preguntas];
      this.disponibles_temp = this.shuffle(this.disponibles_temp);

      this.disponibles_temp.forEach((element) => {
        element.rcorrecta = element.opciones[0];
        element.opciones = thes.shuffle(element.opciones);
      });

      console.log({ resetDisponibles: this.disponibles_temp });
    },

    releaseStandBy() {
      this.standBy = false;
    },
    animarCorazon() {
      // let corazon = this.$refs.corazon;
      // let svg = document.createElement("span");
      // svg.innerHTML = `<svg
      //                 ref=""
      //                 width="40"
      //                 class="ml-2 mt-n2 animado"
      //                 enable-background="new 0 0 24 24"
      //                 id="Layer_1"
      //                 version="1.0"
      //                 viewBox="0 0 24 24"
      //                 xml:space="preserve"
      //                 xmlns="http://www.w3.org/2000/svg"
      //                 xmlns:xlink="http://www.w3.org/1999/xlink"
      //               >
      //                 <path
      //                   fill="#e11616"
      //                   d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
      //                 />
      //               </svg>`;

      // corazon.appendChild(svg);

      let svg2 = document.createElement("span");
      svg2.innerHTML = `<svg
                      ref=""
                      width="100"
                      class="ml-2 mt-n2 animado"
                      enable-background="new 0 0 24 24"
                      id="Layer_1"
                      version="1.0"
                      viewBox="0 0 24 24"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <path
                        fill="#e11616"
                        d="M16.4,4C14.6,4,13,4.9,12,6.3C11,4.9,9.4,4,7.6,4C4.5,4,2,6.5,2,9.6C2,14,12,22,12,22s10-8,10-12.4C22,6.5,19.5,4,16.4,4z"
                      />
                    </svg>`;
      let corazon2 = this.$refs.corazon2;
      corazon2.appendChild(svg2);

      // let corazon1 = document.querySelector(".animado");
      // corazon1.classList.remove("animar");

      setTimeout(function () {
        let corazones = document.querySelectorAll(".animado");
        corazones.forEach((element) => {
          element.classList.add("animar");
        });
      }, 10);
    },
    initJuego() {
      this.encontradas = 0;
      this.comenzo = true;
      this.isRunning = true;
      this.startGame();
    },
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
      return array;
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    terminarJuego() {
      //console.log("terminar juego");
      this.termino = true;
      this.isRunning = false;
      this.started = false;
      clearInterval(this.timer);

      //this.$store.state.loading =  true;
      this.$store.dispatch("showLoader", true);

      //registro bd
      const https = require("https");

      var qData = {
        email: this.userProfile.email,
      };

      qData = {
        time_txt: this.time_txt,
        time: this.time,
        puntos: this.encontradas,
      };
      this.$store.dispatch("registraParticipacion", qData);
    },
    evalua() {
      let puntos = 0;
      this.disponibles_temp.forEach((pregunta) => {
        if (pregunta.seleccionada == pregunta.rcorrecta) {
          puntos += 1;
        }
      });
      return puntos;
    },
    clickElemento(num) {
      if (this.latas["p" + num].encontrada === false) {
        this.latas["p" + num].encontrada = true;

        console.log(this.latas);
        
        this.encontradas_x_nivel ++;
        this.encontradas++;
        console.log({encontradasxnivel: this.encontradas_x_nivel})
        // for (let i = 1; i <= 5; i++) {
        //   if (this.latas["p" + i].encontrada === true) {
        //     this.encontradas++;
        //   }
        // }
        // if (this.encontradas.toString().length == 1)
        //   this.encontradas = "0" + this.encontradas.toString();

        this.encontradas = this.encontradas.toString();

        if (this.encontradas_x_nivel % 5 == 0) {
          this.cambiaNivel();
        }
      }
    },
    startGame() {
      this.started = true;
      this.startTime = moment();

      this.timer = setInterval(() => {
        this.time = moment(moment().diff(this.startTime)).format("mm:ss");
        this.segundos++;

        if (this.segundos >= 30) {
          clearInterval(this.timer);
          this.terminarJuego();
        }
      }, 1000);
    },
    onImageLoad(e) {
      
      this.imageLoadFlag = true;
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
    
  },
};
</script>

<style lang="scss" scoped>
</style>
